import React from "react";
import { PropsType } from "./type";
import { Controller, FieldValues } from "react-hook-form";
import style from "./style.module.css";
import { numberValidRegex } from "../../../utils/numberRegex";
import { div } from "motion/dist/react-client";
export default function Input<T extends FieldValues>(props: PropsType<T>) {
  const {
    clasName,
    classNameContainer,
    label,
    required,
    rightText,
    startIcon,
    endIcon,
    control,
    type,
    name,
    dir,
    ...restProps
  } = props;
  const renderController = () => {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <div
              className={`w-full ${rightText ? "flex items-center gap-1" : ""}`}
            >
              {rightText && (
                <span
                  dir="ltr"
                  className="text-gray-300 text-BodyText/14/Regular"
                >
                  {rightText}
                </span>
              )}
              <input
                type={type === "number" ? "text" : type}
                {...restProps}
                {...field}
                value={
                  type === "number"
                    ? numberValidRegex(field.value ? field.value : "")
                    : field.value
                }
                className={`${
                  rightText
                    ? `outline-none z-0 w-full`
                    : `${props.errors ? "bg-red-100" : "bg-gray-50 "} ${
                        props.errors ? "border-red-500" : "border-gray-200 "
                      } outline-none z-0 ${
                        restProps.disabled && "cursor-not-allowed"
                      } focus:border-gray-700 transition-all duration-200 border w-full border-gray-200 rounded-xl px-2 p-1 relative py-2 bg-white outline-none caret-gray-800 text-gray-500
                  h-[44px] ${startIcon ? "pr-8" : "pr-4"} ${
                        endIcon ? "pl-8" : "pl-4"
                      } ${clasName}`
                } `}
              />
            </div>
          );
        }}
      />
    );
  };
  return (
    <div className={`w-full ${classNameContainer}`}>
      {label && (
        <label className="mb-1 text-gray-950 text-BodyText/14/Regular flex items-center gap-2">
          {label}
          {required && (
            <span className="text-red-500 justify-center items-center">*</span>
          )}
        </label>
      )}
      <div className="flex w-full">
        {startIcon && (
          <div className="absolute right-0 h-full w-fit px-4 flex justify-center items-center">
            {startIcon}
          </div>
        )}

        {control ? (
          <div
            className={`w-full ${
              rightText
                ? `${props.errors ? "bg-red-100" : "bg-gray-50 "} ${
                    props.errors ? "border-red-500" : "border-gray-200 "
                  } outline-none z-0 ${
                    restProps.disabled && "cursor-not-allowed"
                  } focus:border-gray-700 transition-all duration-200 border w-full border-gray-200 rounded-xl px-2 p-1 relative py-2 bg-white outline-none caret-gray-800 text-gray-500
                  h-[44px] ${startIcon ? "pr-8" : "pr-4"} ${
                    endIcon ? "pl-8" : "pl-4"
                  } ${clasName}`
                : ""
            }`}
          >
            {renderController()}
          </div>
        ) : (
          <input
            {...restProps}
            value={
              type === "number"
                ? numberValidRegex(props.value as any)
                : props.value
            }
            type={type === "number" ? "text" : type}
            className={`w-full py-2 bg-white outline-none border border-gray-200 rounded-xl px-2 p-1 relative caret-gray-800 text-gray-950 ${
              startIcon ? "pr-10" : "pr-4"
            } ${endIcon ? "pl-9" : "pl-4"} ${clasName}`}
          />
        )}

        {endIcon && (
          <div className="absolute left-0 h-full w-fit px-4 flex justify-center items-center top-0">
            {endIcon}
          </div>
        )}
      </div>
      {props.errors && (
        <span
          className={` mt-0.5 text-Body-OneLine/14/Regular text-red-500 ${style.text_error}`}
        >
          {props.errors.message}
        </span>
      )}
    </div>
  );
}
